import React, { useState } from "react";
import styles from "./FormPreview.module.scss";
import { useSelector } from "react-redux";

export const FormPreview = () => {
  const { newDialogFormWidget } = useSelector((state) => state?.dialogWF);

  const [showMessages, setShowMessages] = useState(false);
  const [value, setValue] = useState("");

  return (
    <div className={styles.container}>
      <div
        className={styles.formContainer}
        style={{
          background: newDialogFormWidget?.widgetColor,
          borderColor: newDialogFormWidget?.widgetBorderColor,
        }}
      >
        <div
          className={styles.header}
          style={{ borderColor: newDialogFormWidget?.widgetBorderColor }}
        >
          <div
            className={styles.headerTitle}
            style={{ color: newDialogFormWidget?.widgetTextColor }}
          >
            {newDialogFormWidget?.assistantName}
          </div>
        </div>
        {showMessages && (
          <div
            id="messages-container-ai-sm"
            className={`${styles.messagesContainer} ${
              showMessages ? styles.expanded : ""
            }`}
          >
            <div
              className={styles.outcome}
              style={{ color: newDialogFormWidget?.widgetTextColor }}
            >
              Привет!
            </div>
            <div
              className={styles.income}
              style={{ color: newDialogFormWidget?.widgetTextColor }}
            >
              Привет, чем могу помочь?
            </div>
          </div>
        )}

        <div
          className={styles.inputContainer}
          style={{ background: newDialogFormWidget?.widgetInputColor }}
        >
          <textarea
            name="form-input-ai-sm"
            id="form-input-ai-sm"
            cols="3"
            rows="1"
            className={styles.input}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="О чем поговорим?"
            style={{ color: newDialogFormWidget?.widgetTextColor }}
          ></textarea>
          <div
            id="send-button"
            className={`${styles.button} ${
              value.length < 1 ? styles.disabled : ""
            }`}
            onClick={() => setShowMessages(!showMessages)}
            style={{
              background:
                value.length > 0
                  ? newDialogFormWidget?.widgetButtonColor
                  : newDialogFormWidget?.widgetButtonDisabledColor,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 512 512"
            >
              <path
                fill="white"
                d="M511.1 255.1c0 12.8-7.625 24.38-19.41 29.41L44.6 477.4c-4.062 1.75-8.344 2.594-12.59 2.594c-8.625 0-17.09-3.5-23.28-10.05c-9.219-9.766-11.34-24.25-5.344-36.27l73.66-147.3l242.1-30.37L77.03 225.6l-73.66-147.3C-2.623 66.3-.4982 51.81 8.72 42.05c9.25-9.766 23.56-12.75 35.87-7.453L492.6 226.6C504.4 231.6 511.1 243.2 511.1 255.1z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
